export const OBSERVER_OPTIONS = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1,
};
